import Vue from "vue";
import axios from "axios";

let baseURL;

const prodURL =
    window.location.origin.includes("indsiders.com") &&
    !window.location.origin.includes("dev") &&
    !window.location.origin.includes("homolog");
const homologURL = window.location.origin.includes("homolog");
const hostname = window.location.hostname;
const localhostURL = hostname === "localhost" || hostname === "127.0.0.1";
const localNetworkURL =
    localhostURL ||
    /^10\./.test(hostname) ||
    /^192\.168\./.test(hostname) ||
    /^172\.(1[6-9]|2\d|3[01])\./.test(hostname);
const localApiProxy =
    process.env.NODE_ENV === "development" && localNetworkURL && !localhostURL;
const apiV2Override = process.env.VUE_APP_API_V2_URL;


// URLs API PHP
if (localApiProxy) {
    baseURL = "/mysfc-php-api";
} else if (prodURL) {
    baseURL = "https://api-php-v2.indsiders.com";
} else if (homologURL) {
    baseURL = "https://app-indsiders-myind-api-php-homolog.azurewebsites.net";
} else {
    baseURL = "https://app-indsiders-myind-api-php-dev.azurewebsites.net";
}

const axiosIns = axios.create({
    baseURL
});

// Adiciona o accessToken nos requests
axiosIns.interceptors.request.use(
    (config) => {
        const isSwitchUser = config.url?.includes("switch-user") || config.headers?.skipAuthHeader;
        if (config.headers?.skipAuthHeader) {
            delete config.headers.skipAuthHeader;
        }

        if (!isSwitchUser) {
            const { accessToken } = Vue.prototype.$cookies.get("userInfo") || {};
            if (accessToken) {
                config.headers.Authorization = `Bearer ${accessToken}`;
                config.headers.token = accessToken;
            }
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// URLs API .Net
if (apiV2Override) {
    baseURL = apiV2Override;
} else if (localApiProxy) {
    baseURL = "/mysfc-v2-api";
} else if (prodURL) {
    baseURL = "https://api-v2.indsiders.com";
} else if (localhostURL) {
    baseURL = 'https://localhost:57904';
} else if (homologURL) {
    baseURL = "https://app-indsiders-myind-api-homolog.azurewebsites.net";
} else {
    baseURL = "https://app-indsiders-myind-api-dev.azurewebsites.net";
}

const evoAxiosIns = axios.create({
    baseURL
});

let redirectingToMyIndLogin = false;

const redirectToMyIndLogin = () => {
    if (redirectingToMyIndLogin) return;

    redirectingToMyIndLogin = true;
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userData");
    localStorage.removeItem("sites");
    localStorage.removeItem("reloaded");

    const domain = window.location.hostname.endsWith("indsiders.com")
        ? "indsiders.com"
        : null;
    Vue.prototype.$cookies.remove("userInfo", null, domain);
    Vue.prototype.$cookies.remove("company", null, domain);

    const myIndLink = Vue.prototype.$myIndLink || "https://myind-dev.indsiders.com/";
    window.location.assign(`${myIndLink}login`);
};

evoAxiosIns.interceptors.request.use(   
    (config) => {
        const isSwitchUser = config.url?.includes("switch-user") || config.headers?.skipAuthHeader;
        if (config.headers?.skipAuthHeader) {
            delete config.headers.skipAuthHeader;
        }

        if (!isSwitchUser) {
            const { temporaryToken } = Vue.prototype.$cookies.get("userInfo") || {};
            const token = temporaryToken || localStorage.getItem("accessToken");
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
                config.headers.token = token;
            }
        }
        return config;
    },
    (error) => Promise.reject(error)
);

evoAxiosIns.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) redirectToMyIndLogin();
        return Promise.reject(error);
    }
);

let myqualityBaseURL;
if (localApiProxy) {
    myqualityBaseURL = "/mysfc-quality-api";
} else if (prodURL) {
    myqualityBaseURL = "https://app-indsiders-myquality-api-prod.azurewebsites.net";
} else if (homologURL) {
    myqualityBaseURL = "https://app-indsiders-myquality-api-homolog.azurewebsites.net";
} else if (localhostURL) {
    myqualityBaseURL = process.env.VUE_APP_MYQUALITY_API_URL || "https://localhost:54000";
} else {
    myqualityBaseURL = "https://app-indsiders-myquality-api-dev.azurewebsites.net";
}

const myqualityAxiosIns = axios.create({
    baseURL: myqualityBaseURL
});

myqualityAxiosIns.interceptors.request.use(
    (config) => {
        const { temporaryToken } = Vue.prototype.$cookies.get("userInfo") || {};
        if (temporaryToken) {
            config.headers.Authorization = `Bearer ${temporaryToken}`;
            config.headers.token = temporaryToken;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

let myDashBaseURL;
if (localApiProxy) {
    myDashBaseURL = "/mysfc-dashboard-api";
} else if (prodURL) {
    myDashBaseURL = "https://app-indsiders-mydashboard-api-prod.azurewebsites.net";
} else if (homologURL) {
    myDashBaseURL = "https://app-indsiders-mydashboard-api-homolog.azurewebsites.net";
} else {
    myDashBaseURL = "https://app-indsiders-mydashboard-api-dev.azurewebsites.net";
}

const myDashboardAxiosIns = axios.create({
    baseURL: myDashBaseURL
});

myDashboardAxiosIns.interceptors.request.use(
    (config) => {
        const { temporaryToken } = Vue.prototype.$cookies.get("userInfo") || {};
        if (temporaryToken) {
            config.headers.Authorization = `Bearer ${temporaryToken}`;
            config.headers.token = temporaryToken;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

Vue.prototype.$http = axiosIns;
Vue.prototype.$http2 = evoAxiosIns;
Vue.prototype.$http3 = myqualityAxiosIns;
Vue.prototype.$http4 = myDashboardAxiosIns;

export { myqualityAxiosIns as http3, myDashboardAxiosIns as http4 };
export default axiosIns;
